import React from 'react';
import banner from '../../images/banner.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import Header from '../Header/Header';

const Banner = () => {
    return (
        <div style={{ backgroundColor: '#413B65' }}>
            <Header></Header>
            <div className="row d-flex align-items-center pt-5 text-white w-100" style={{ overflowX: 'hidden' }}>
                <div data-aos="fade-right" className="col-lg-5 pt-5 order-2 order-lg-1">
                    <img
                        className="img-fluid"
                        src={banner} alt="Saalim Shadman"
                    />
                </div>
                <div data-aos="fade-left" className="col-11 col-lg-6 mx-auto ms-lg-auto text-start order-1 order-lg-2">
                    <h1 className="fw-bold">SAALIM SHADMAN</h1>
                    <p>A programmer who believes, from pushing code for grades to pushing code to make people's lives easier, we will change the world. I am a computer science student whilst having experience of working as a <strong>Lead Frontend Developer</strong> at an Australian Startup, ProcessHQ as well as a <strong>Frontend Engineer</strong> at a US Company, TeammateMe.</p>
                    <a href="https://drive.google.com/u/0/uc?id=1E_mU6yUu6-j4yO1oynWsJ6dysuWl-5yj&export=download" download className="btn btn-outline-light text-uppercase mt-2"><small>Download Resume <FontAwesomeIcon icon={faDownload} /></small></a>
                </div>
            </div>
        </div>

    );
};

export default Banner;